import { contactInfo } from "@/mocks/homeData";

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/60">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-8">
              <div className="flex-1">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">
                  {contactInfo.title}
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                  {contactInfo.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {contactInfo.services.map((s, i) => (
                    <span
                      key={i}
                      className="px-3 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-3 min-w-[180px]">
                <div className="flex items-center gap-3 text-sm text-foreground-600">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </div>
                  <span className="text-xs break-all">{contactInfo.email}</span>
                </div>
                <button className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer font-label">
                  {contactInfo.cta}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}